// Added submenu button, in order to dropdown submenu
// Style sub-menu__button element to your needs

export {}

const arrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512">
<path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
</svg>`

const itemsWithSubmenu = document.querySelectorAll(".menu-item-has-children, .page_item_has_children")
itemsWithSubmenu.forEach((item) => {
  item.insertAdjacentHTML("beforeend", `<span class="sub-menu__button">${arrowSvg}</span>`)

  const submenuButton = item.querySelector(".sub-menu__button")

  const handleSubmenu = (event: Event) => {
    event.preventDefault()
    item.classList.toggle("--open")
  }

  submenuButton?.addEventListener("click", handleSubmenu)
})
